<app-slider></app-slider>
<!-- <app-booking-component></app-booking-component> -->

<app-home-about></app-home-about>
<app-rooms></app-rooms>
<app-notch></app-notch>

